export const resizeAndOptimizeImage = (inputURL: string) => {
  const imgUrl = new URL(inputURL)

  imgUrl.searchParams.set('dpr', '2')
  imgUrl.searchParams.set('format', 'jpg')
  imgUrl.searchParams.set('opto', '')
  imgUrl.searchParams.set('width', '160')
  imgUrl.searchParams.set('crop', '4:3')

  return imgUrl.toString().concat('&auto=avif,webp')
}
